<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <hsq-panel>
      升级配置
      <Form slot="content" :label-width="100">
        <Row :gutter="8" class="last-row">
          <Col span="6">
            <FormItem label="当前项目">
              <Input :value="project" readonly />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="终端起始ID">
              <Input v-model="updateInfo.startDeviceId" readonly/>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="终端结束ID">
              <Input v-model="updateInfo.endDeviceId" readonly/>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="固件版本">
              <Input v-model="updateInfo.codeId" readonly />
            </FormItem>
          </Col>
        </Row>
      </Form>
    </hsq-panel>
    <hsq-panel style="margin-top: 16px; display:flex; flex-direction: column; flex-grow: 1">
      升级日志
      <Input slot="content" readonly style="height: 100%" class="textString" v-model="logString" type="textarea" placeholder="显示升级日志"></Input>
    </hsq-panel>
  </div>
</template>

<script>
  import hsqPanel from "../components/hsqPanel";
  export default {
    components: {
      hsqPanel
    },
    data() {
      return {
        updateInfo: null,
        updateResult: null
      }
    },
    computed: {
      project() {
        if (this.updateInfo && this.updateInfo.projectId) {
          return `${this.updateInfo.projectId} - ${this.updateInfo.projectName}`;
        } else {
          return '';
        }
      },
      logString() {
        return this.updateResult.logString;
      }
    },
    created() {
      this.updateInfo = this.$coreData.updateInfo;
      this.updateResult = this.$coreData.updateResult;
      this.$coreData.initMqtt();
    }
  }
</script>

<style scoped>
.last-row .ivu-form-item {
  margin-bottom: 0 !important;
}

.textString textarea {
  height: 100% !important;
}
</style>